// extracted by mini-css-extract-plugin
export var button = "newbutton-module--button--LpVqp";
export var button__icon = "newbutton-module--button__icon--yqmSh";
export var button__icon_right = "newbutton-module--button__icon_right--H0y5A";